/**
 * at-93: o que acontece com os colaboradores do veículo quando o Chefe o move de esteira.
 *
 * Existe porque a decisão é a MESMA em três telas — "Alterar esteira", "Aprovar esteira" e a
 * aprovação de horas do Tempo e SLA — e os rótulos não podem divergir entre elas: o Chefe decide
 * a mesma coisa nos três lugares, e ler "Não atribuir" num e "Deixar sem colaborador" noutro faz
 * parecer que são escolhas diferentes. Mesma regra de extração do `badge-status.css` e do
 * `modal-close-button.css`: a segunda tela que precisa do texto é o sinal de extrair.
 *
 * 🔴 `NAO_ATRIBUIR` é o PADRÃO em todas elas (pedido do Victor, 07/09/2026): mover o veículo
 * levando junto o colaborador atual deixou de acontecer por omissão e passou a ser ato explícito.
 * Antes, "nada escolhido" significava "os vinculados continuam" no Alterar esteira e no Tempo e
 * SLA — e os Chefes mandavam o veículo para a próxima esteira com o colaborador atual sem querer.
 */
export type EscolhaColaborador =
  | { modo: 'NAO_ATRIBUIR' }
  | { modo: 'MANTER' }
  | { modo: 'ADICIONAR'; collaboratorId: string; fullName: string | null };

/** A escolha padrão: o veículo segue sem colaborador. */
export const ESCOLHA_PADRAO: EscolhaColaborador = { modo: 'NAO_ATRIBUIR' };

/**
 * Textos exibidos ao usuário. Sem emoji e em gênero neutro (regras do projeto): as descrições
 * falam do veículo e de "quem está nele", nunca "será desvinculado" — o sistema não guarda o
 * gênero de quem está no cadastro.
 */
export const TEXTOS_ESCOLHA_COLABORADOR = {
  naoAtribuir: {
    rotulo: 'Não atribuir',
    /** Quando o veículo já tem gente vinculada — a consequência precisa aparecer no rótulo. */
    descricaoComVinculados: 'O veículo segue sem colaborador; quem está nele sai',
    descricaoSemVinculados: 'O veículo segue sem colaborador',
  },
  manter: {
    rotulo: 'Manter os colaboradores atuais',
    descricao: 'Quem está no veículo continua responsável na esteira nova',
  },
  escolher: {
    rotulo: 'Ou escolher um colaborador (opcional)',
    /** at-45/ADR 0020: atribuir SOMA — a escolha não substitui quem já está no veículo. */
    descricao: 'Somado a quem continua no veículo',
  },
} as const;
